import { render } from "./SeedJung_Inquiry.vue?vue&type=template&id=63160aa2&scoped=true"
import script from "./SeedJung_Inquiry.vue?vue&type=script&lang=js"
export * from "./SeedJung_Inquiry.vue?vue&type=script&lang=js"

import "./SeedJung_Inquiry.vue?vue&type=style&index=0&id=63160aa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63160aa2"]])

export default __exports__